import { createAsyncThunk } from "@reduxjs/toolkit";
import { APICore } from "../../helpers/api/apiCore";
import * as Url from "../../helpers/api/ApiEndpoint";
import { showError, showSuccess } from "../../helpers/toaster";

const api = new APICore();

export const createPersona = createAsyncThunk(
  "persona/createPersona",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CREATE_PERSONA, data);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const getPersona = createAsyncThunk(
  "persona/getPersona",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(Url.GET_PERSONA);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const getPersonaById = createAsyncThunk(
  "persona/getPersonaById",
  async (id, { rejectWithValue }) => {
    try {
      console.log('Making API call to:', `${Url.GET_PERSONA}?personaId=${id}`);
      const response = await api.get(`${Url.GET_PERSONA}?personaId=${id}`);
      console.log('API Response in thunk:', response);
      return response.data;
    } catch (error) {
      console.log('API Error in thunk:', error);
      showError(error);
      return rejectWithValue(error);
    }
  }
);

export const editPersona = createAsyncThunk(
  "persona/editPersona",
  async (data, { rejectWithValue }) => {
    try {
      console.log('Edit API call with data:', data);
      const response = await api.create(Url.CREATE_PERSONA, data);
      console.log('Edit API response:', response);
      return response.data;
    } catch (error) {
      console.log('Edit API error:', error);
      showError(error);
      return rejectWithValue(error);
    }
  }
);

export const deletePersona = createAsyncThunk(
  "persona/deletePersona",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `${Url.DELETE_PERSONA}?personaId=${data?.personaId}`
      );
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);
